









































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { bus } from "../../main";
import * as data from "../../_store/data.module";
import * as temp from "../../_store/temp.module";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import { RichiestaTirEstivi } from "../../_models/richiestaTirEstivi";

@Component
export default class EditRichiestaTirEstivo extends Vue {
  @Prop() info!: RichiestaTirEstivi;
  private e1: number;
  private comuni: any;
  private searchComuni: object | null;
  private isLoadingComuni: boolean;
  private indirizziStudio: any;
  private consulenteOptions: string[];
  private ruolo: string;

  private comuneTirocinio: string;
  private provinciaTirocinio: string;
  private capTirocinio: string;
  private indirizzoTirocinio: string;
  private lavoratoriSede: string;
  private tirociniSede: string;
  private tirociniDisabiliSede: string;
  private attivitàTirocinio: string;
  private usoFuoriSede: string;
  private indirizzoStudio: string;

  private consulente: string;
  private denominazioneConsulente: string;
  private referenteConsulente: string;
  private telefonoConsulente: string;
  private emailConsulente: string;

  private cognomeTirocinante: string | null;
  private nomeTirocinante: string | null;
  private classeTirocinante: string | null;

  private idCPIstat: number

  private comuneTirocinioRules: [boolean | string];
  private provinciaTirocinioRules: [boolean | string];
  private capTirocinioRules: [boolean | string];
  private indirizzoTirocinioRules: [boolean | string];
  private lavoratoriSedeRules: [boolean | string];
  private tirociniSedeRules: [boolean | string];
  private attivitàTirocinioRules: [boolean | string];
  private indirizzoStudioRules: [boolean | string];

  private consulenteRules: [boolean | string];
  private denominazioneConsulenteRules: [boolean | string];
  private referenteConsulenteRules: [boolean | string];
  private telefonoConsulenteRules: [boolean | string];
  private emailConsulenteRules: [boolean | string];

  private cognomeTirocinanteRules: [boolean | string];
  private nomeTirocinanteRules: [boolean | string];
  private classeTirocinanteRules: [boolean | string];

  constructor() {
    super();
    this.e1 = 1;
    this.comuni = [];
    this.searchComuni = null;
    this.isLoadingComuni = false;
    this.indirizziStudio = [];
    this.consulenteOptions = ["ESTERNO", "INTERNO"];
    this.ruolo = "LEGALE RAPPRESENTANTE";

    this.comuneTirocinio = this.info.comuneTirocinio;
    this.provinciaTirocinio = this.info.provinciaTirocinio;
    this.capTirocinio = this.info.capTirocinio;
    this.indirizzoTirocinio = this.info.indirizzoTirocinio;
    this.lavoratoriSede = this.info.lavoratoriSede;
    this.tirociniSede = this.info.tirociniSede;
    this.tirociniDisabiliSede = this.info.tirociniDisabiliSede;
    this.attivitàTirocinio = this.info.attivitàTirocinio;
    this.usoFuoriSede = String(this.info.usoFuoriSede);
    this.indirizzoStudio = this.info.indirizzoStudio;

    this.consulente = this.info.consulente;
    this.denominazioneConsulente = this.info.denominazioneConsulente;
    this.referenteConsulente = this.info.referenteConsulente;
    this.telefonoConsulente = this.info.telefonoConsulente;
    this.emailConsulente = this.info.emailConsulente;

    this.cognomeTirocinante = this.info.cognomeTirocinante;
    this.nomeTirocinante = this.info.nomeTirocinante;
    this.classeTirocinante = this.info.classeTirocinante;

    this.idCPIstat = this.info.idCPIstat

    this.comuneTirocinioRules = [true];
    this.provinciaTirocinioRules = [true];
    this.capTirocinioRules = [true];
    this.indirizzoTirocinioRules = [true];
    this.lavoratoriSedeRules = [true];
    this.tirociniSedeRules = [true];
    this.attivitàTirocinioRules = [true];
    this.indirizzoStudioRules = [true];

    this.consulenteRules = [true];
    this.denominazioneConsulenteRules = [true];
    this.referenteConsulenteRules = [true];
    this.telefonoConsulenteRules = [true];
    this.emailConsulenteRules = [true];

    this.cognomeTirocinanteRules = [true];
    this.nomeTirocinanteRules = [true];
    this.classeTirocinanteRules = [true];
  }

  @Watch("provinciaTirocinio")
  onProvinciaTirocinioChange(value: string) {
    this.provinciaTirocinio = value.toUpperCase();
  }
  @Watch("referenteConsulente")
  onReferenteConsulenteChange(value: string) {
    this.referenteConsulente = value.toUpperCase();
  }

  @Watch("searchComuni")
  onComuniChanged(value: string) {
    if (this.comuni.length > 0) return;
    this.isLoadingComuni = true;
    data
      .dispatchComuniList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.comuni = response;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      })
      .finally(() => (this.isLoadingComuni = false));
  }

  validazioneLavoratoriSede() {
    if (this.lavoratoriSede === "" || this.lavoratoriSede === null) {
      this.lavoratoriSedeRules = ["Numero lavoratori necessario"];
    } else {
      this.lavoratoriSedeRules = [true];
    }
  }

  validazioneTirociniSede() {
    if (this.tirociniSede === "" || this.tirociniSede === null) {
      this.tirociniSedeRules = ["Numero tirocini in corso necessario"];
    } else {
      this.tirociniSedeRules = [true];
    }
  }

  validazioneComuneTirocinio() {
    if (this.comuneTirocinio === "" || this.comuneTirocinio === null) {
      this.comuneTirocinioRules = ["Comune tirocinio necessario"];
    } else {
      this.comuneTirocinioRules = [true];
    }
  }

  validazioneProvinciaTirocinio() {
    var valid: boolean = false;
    if (this.provinciaTirocinio === "" || this.provinciaTirocinio === null) {
      this.provinciaTirocinioRules = ["Provincia tirocinio necessaria"];
    } else {
      valid = /^[A-Z]{2}$/.test(this.provinciaTirocinio);
      if (valid) {
        this.provinciaTirocinioRules = [true];
      } else {
        this.provinciaTirocinioRules = [
          "La provincia non ha un formato corretto"
        ];
      }
    }
  }

  validazioneCapTirocinio() {
    var valid: boolean = false;
    if (this.capTirocinio === "" || this.capTirocinio === null) {
      this.capTirocinioRules = ["Cap tirocinio necessario"];
    } else {
      valid = /^[0-9]{5}$/.test(this.capTirocinio);
      if (valid) {
        this.capTirocinioRules = [true];
      } else {
        this.capTirocinioRules = ["Il Cap non ha un formato corretto"];
      }
    }
  }

  validazioneIndirizzoTirocinio() {
    var valid: boolean = false;
    if (this.indirizzoTirocinio === "" || this.indirizzoTirocinio === null) {
      this.indirizzoTirocinioRules = ["Indirizzo tirocinio necessario"];
    } else {
      valid = /^[a-zA-Z00-9ìèéùòà,.'\x20/-]{2,100}$/.test(
        this.indirizzoTirocinio
      );
      if (valid) {
        this.indirizzoTirocinioRules = [true];
      } else {
        this.indirizzoTirocinioRules = [
          "L'Indirizzo non ha un formato corretto"
        ];
      }
    }
  }

  validazioneConsulente() {
    if (this.consulente === "" || this.consulente === null) {
      this.consulenteRules = ["Indicazione consulente necessaria"];
    } else {
      this.consulenteRules = [true];
    }
  }

  validazioneDenominazioneConsulente() {
    var valid: boolean = false;
    if (
      this.denominazioneConsulente === "" ||
      this.denominazioneConsulente === null
    ) {
      this.denominazioneConsulenteRules = ["Denominazione necessaria"];
    } else {
      valid = /^[a-zA-Z0-9ìèéùòà'&.\x20/-]{2,100}$/.test(
        this.denominazioneConsulente
      );
      if (valid) {
        this.denominazioneConsulenteRules = [true];
      } else {
        this.denominazioneConsulenteRules = [
          "La denominazione deve essere minore di 100 caratteri"
        ];
      }
    }
  }

  validazioneReferente() {
    var valid: boolean = false;
    if (this.referenteConsulente === "" || this.referenteConsulente === null) {
      this.referenteConsulenteRules = ["Denominazione necessaria"];
    } else {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,100}$/.test(this.referenteConsulente);
      if (valid) {
        this.referenteConsulenteRules = [true];
      } else {
        this.referenteConsulenteRules = [
          "Il referente deve essere minore di 100 caratteri e non deve contenere numeri"
        ];
      }
    }
  }

  validazioneTelefonoConsulente() {
    var valid: boolean = false;
    if (this.telefonoConsulente === "" || this.telefonoConsulente === null) {
      this.telefonoConsulenteRules = ["Telefono necessario"];
    } else {
      valid = /[0-9]{8,15}$/.test(this.telefonoConsulente);
      if (valid) {
        this.telefonoConsulenteRules = [true];
      } else {
        this.telefonoConsulenteRules = [
          "Il numero di telefono non ha un formato corretto"
        ];
      }
    }
  }

  validazioneEmailConsulente() {
    var valid: boolean = false;
    if (this.emailConsulente === "" || this.emailConsulente === null) {
      this.emailConsulenteRules = ["Email necessaria"];
    } else {
      valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(
        this.emailConsulente
      );
      if (valid) {
        this.emailConsulenteRules = [true];
      } else {
        this.emailConsulenteRules = ["L'email non ha un formato corretto"];
      }
    }
  }

  validazioneAttivitaTirocinio() {
    var valid: boolean = false;
    if (this.attivitàTirocinio === "" || this.attivitàTirocinio === null) {
      this.attivitàTirocinioRules = ["Obiettivi del tirocinio necessari"];
    } else {
      valid = /^[0-9a-zA-Zìèéùòà',.\x20]{2,250}$/.test(this.attivitàTirocinio);
      if (valid) {
        this.attivitàTirocinioRules = [true];
      } else {
        this.attivitàTirocinioRules = [
          "Obiettivi tirocinio non può avere più di 250 caratteri e non deve contenere caratteri speciali"
        ];
      }
    }
  }

  validazioneIndirizzoStudio() {
    if (this.indirizzoStudio === "" || this.indirizzoStudio === null) {
      this.indirizzoStudioRules = ["Settore formativo necessario"];
    } else {
      this.indirizzoStudioRules = [true];
    }
  }

  validazioneNomeTirocinante() {
    var valid: boolean = false;
    if (this.nomeTirocinante !== null && this.nomeTirocinante !== "") {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.nomeTirocinante);
      if (valid) {
        this.nomeTirocinanteRules = [true];
      } else {
        this.nomeTirocinanteRules = [
          "Nome Tirocinante deve essere compreso tra i 2 e i 50 caratteri"
        ];
      }
    } else {
      this.nomeTirocinanteRules = [true];
    }
  }

  validazioneCognomeTirocinante() {
    var valid: boolean = false;
    if (this.cognomeTirocinante !== null && this.cognomeTirocinante !== "") {
      valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.cognomeTirocinante);
      if (valid) {
        this.cognomeTirocinanteRules = [true];
      } else {
        this.cognomeTirocinanteRules = [
          "Cognome Tirocinante deve essere compreso tra i 2 e i 50 caratteri"
        ];
      }
    } else {
      this.cognomeTirocinanteRules = [true];
    }
  }

  validazioneClasseTirocinante() {
    var valid: boolean = false;
    if (this.classeTirocinante !== null && this.classeTirocinante !== "") {
      // valid = /^[a-zA-Z0-9'\x20]{2,50}$/.test(this.classeTirocinante);
      // if (valid) {
        this.classeTirocinanteRules = [true];
      // } else {
      //   this.classeTirocinanteRules = [
      //     "Classe non può essere più lungo di 3 caratteri"
      //   ];
      // }
    } else {
      this.classeTirocinanteRules = [true];
    }
  }

  validazioneEventualeTirocinante() {
    // if((this.cognomeTirocinante !== "" && this.nomeTirocinante !== "") && this.classeTirocinante !== ""){

    // }else{
    // if (
    //   (this.cognomeTirocinante !== null && this.cognomeTirocinante !== "") ||
    //   (this.nomeTirocinante !== null && this.nomeTirocinante !== "") ||
    //   (this.classeTirocinante !== null && this.classeTirocinante !== "")
    // ) {
    if (this.cognomeTirocinante === "" || this.cognomeTirocinante === null) {
      this.cognomeTirocinanteRules = ["Cognome tirocinante necessario"];
    }
    if (this.nomeTirocinante === "" || this.nomeTirocinante === null) {
      this.nomeTirocinanteRules = ["Nome tirocinante necessario"];
    }
    if (this.classeTirocinante === "" || this.classeTirocinante === null) {
      this.classeTirocinanteRules = ["Classe tirocinante necessaria"];
    }
    // }
    // }
  }

  back() {
    this.e1 = 1;
    this.consulenteRules = [true];
    this.denominazioneConsulenteRules = [true];
    this.referenteConsulenteRules = [true];
    this.telefonoConsulenteRules = [true];
    this.emailConsulenteRules = [true];
  }

  backDue() {
    this.e1 = 2;
    this.cognomeTirocinanteRules = [true];
    this.nomeTirocinanteRules = [true];
    this.classeTirocinanteRules = [true];
  }

  close() {
    this.comuneTirocinioRules = [true];
    this.provinciaTirocinioRules = [true];
    this.capTirocinioRules = [true];
    this.indirizzoTirocinioRules = [true];
    this.lavoratoriSedeRules = [true];
    this.tirociniSedeRules = [true];
    this.attivitàTirocinioRules = [true];
    this.indirizzoStudioRules = [true];

    this.consulenteRules = [true];
    this.denominazioneConsulenteRules = [true];
    this.referenteConsulenteRules = [true];
    this.telefonoConsulenteRules = [true];
    this.emailConsulenteRules = [true];

    this.cognomeTirocinanteRules = [true];
    this.nomeTirocinanteRules = [true];
    this.classeTirocinanteRules = [true];
    bus.$emit("closeEditDialog");
    this.e1 = 1;
  }

  async executeTirocinioTest() {
    this.validazioneLavoratoriSede();
    this.validazioneTirociniSede();
    this.validazioneComuneTirocinio();
    this.validazioneProvinciaTirocinio();
    this.validazioneCapTirocinio();
    this.validazioneIndirizzoTirocinio();
    this.validazioneAttivitaTirocinio();
    this.validazioneIndirizzoStudio();
  }

  async executeConsulenteTest() {
    this.validazioneConsulente();
    this.validazioneDenominazioneConsulente();
    this.validazioneReferente();
    this.validazioneTelefonoConsulente();
    this.validazioneEmailConsulente();
  }

  async executeTirocinanteTest() {
    if (
      (this.cognomeTirocinante !== null && this.cognomeTirocinante !== "") ||
      (this.nomeTirocinante !== null && this.nomeTirocinante !== "") ||
      (this.classeTirocinante !== null && this.classeTirocinante !== "")
    ) {
      this.validazioneEventualeTirocinante();
    }
  }

  next() {
    this.executeTirocinioTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        this.e1 = 2;
      }
    });
  }

  nextDue() {
    this.executeConsulenteTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        this.e1 = 3;
      }
    });
  }

  save() {
    var richiestaTirEstivo: RichiestaTirEstivi;
    var utilizzoFuoriSede: boolean;
    var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
    var cognomeT: string | null;
    var nomeT: string | null;
    var classeT: string | null;
    this.executeTirocinanteTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        cognomeT = this.cognomeTirocinante;
        nomeT = this.nomeTirocinante;
        classeT = this.classeTirocinante;
        if (cognomeT === "") {
          cognomeT = null;
          nomeT = null;
          classeT = null;
        }
        if (this.usoFuoriSede === "false") {
          utilizzoFuoriSede = false;
        } else {
          utilizzoFuoriSede = true;
        }
        richiestaTirEstivo = {
          idAzienda: enterpriseInfo.idAzienda,
          denominazioneAzienda: enterpriseInfo.denominazioneAzienda,
          cognomeRappresentanteAzienda:
            enterpriseInfo.cognomeRappresentanteAzienda,
          titolo: enterpriseInfo.titolo,
          nomeRappresentanteAzienda: enterpriseInfo.nomeRappresentanteAzienda,
          statoNascitaRappresentante: enterpriseInfo.statoNascitaRappresentante,
          dataNascitaRappresentante: enterpriseInfo.dataNascitaRappresentante,
          luogoNascitaRappresentante: enterpriseInfo.luogoNascitaRappresentante,
          comuneAzienda: enterpriseInfo.comuneAzienda,
          idCapComuneAzienda: enterpriseInfo.idCapComuneAzienda,
          provinciaAzienda: enterpriseInfo.provinciaAzienda,
          indirizzoAzienda: enterpriseInfo.indirizzoAzienda,
          telefono1Azienda: enterpriseInfo.telefono1Azienda,
          telefono2Azienda: enterpriseInfo.telefono2Azienda,
          faxAzienda: enterpriseInfo.faxAzienda,
          emailAzienda: enterpriseInfo.emailAzienda,
          pecAzienda: enterpriseInfo.pecAzienda,
          sitoAzienda: enterpriseInfo.sitoAzienda,
          attivitàAzienda: enterpriseInfo.attivitàAzienda,
          dipendentiAzienda: enterpriseInfo.dipendentiAzienda,
          committenzaAzienda: enterpriseInfo.committenzaAzienda,
          associata: enterpriseInfo.associata,
          artigiana: enterpriseInfo.artigiana,
          pIva: enterpriseInfo.pIva,
          codAzienda: enterpriseInfo.codAzienda,
          idAteco: enterpriseInfo.idAteco,
          // idIstat: enterpriseInfo.idIstat,
          descrizioneAteco: enterpriseInfo.descrizioneAteco,
          descrizioneIstat: enterpriseInfo.descrizioneIstat,
          cap: enterpriseInfo.cap,
          idNazioneAzienda: enterpriseInfo.idNazioneAzienda,
          nazioneAzienda: enterpriseInfo.nazioneAzienda,

          lavoratoriSede: this.lavoratoriSede,
          tirociniSede: this.tirociniSede,
          tirociniDisabiliSede: this.tirociniDisabiliSede,
          consulente: this.consulente,
          provinciaTirocinio: this.provinciaTirocinio,
          comuneTirocinio: this.comuneTirocinio,
          capTirocinio: this.capTirocinio,
          indirizzoTirocinio: this.indirizzoTirocinio,
          denominazioneConsulente: this.denominazioneConsulente,
          referenteConsulente: this.referenteConsulente,
          telefonoConsulente: this.telefonoConsulente,
          emailConsulente: this.emailConsulente,
          attivitàTirocinio: this.attivitàTirocinio,
          indirizzoStudio: this.indirizzoStudio,
          cognomeTirocinante: cognomeT,
          nomeTirocinante: nomeT,
          classeTirocinante: classeT,
          usoFuoriSede: utilizzoFuoriSede,
          ruolo: this.ruolo,
          idAziendaIstitutoAnno: 0,
          nomeIndirizzoStudio: "",
          nomeSettore: "",
          idRichiesta: this.info.idRichiesta,
          idCPIstat: this.idCPIstat,
          descrizioneCPIstat: "",
          idIscrizioneAttivita: this.info.idIscrizioneAttivita,
          idStatoUtente: 2,
          codRappresentate: "",
          confCommercio: false,
          altraAssociazione: false

          // idIstituto: this.params.idIstituto,
          // idAnnoScolastico: this.params.idAnnoScolastico
        };
        user
          .dispatchUpdateRichiestaTirEstivo(
            this["$store"],
            richiestaTirEstivo
          )
          .then(() => {
            bus.$emit("refreshTirEstiviTable");
            bus.$emit(
              "successfullOperation",
              "Disponibilità aggiornata con successo"
            );
            this.close();
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      }
    });
  }

  created() {
    var indirizzo = {
      idIndirizzo: 0,
      nomeIndirizzo: ""
    };
    var indirizzi: any[] = [];
    var idIstituto = temp.readIdIstituto(this["$store"]);
    if (idIstituto !== null) {
      data
        .dispatchListaIndirizziStudi(this["$store"], idIstituto)
        .then(response => {
          response.forEach(function(element: any) {
            indirizzo = {
              idIndirizzo: element.Id,
              nomeIndirizzo:
                element.NomeSettore + " INDIRIZZO " + element.NomeIndirizzo
            };
            indirizzi.push(indirizzo);
          });
          this.indirizziStudio = indirizzi;
          data
            .dispatchComuniList(this["$store"])
            .then(result => {
              var obj = {
                id: 0,
                località: ""
              };
              result.forEach(element => {
                obj = {
                  id: element.id,
                  località: element.località
                };
                this.comuni.push(obj);
              });
            })
            .catch(error => {
              bus.$emit(
                "errorOperation",
                "Errore nel caricamento della lista comuni"
              );
            });
        })
        .catch(error => {
          if (error.status === 401) {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          } else {
            bus.$emit(
              "errorOperation",
              "Errore nel caricamento della lista indirizzi studio"
            );
          }
        });
    } else {
      this.close();
      bus.$emit(
        "errorOperation",
        "Errore nel caricamento della lista indirizzi studio"
      );
    }
  }
}
